// @ts-nocheck

import { SpineAnimationIds } from '../../../../types/animations';

import json from './victory.json';
import image from './victory.png';

import atlas from '!!raw-loader!./victory.atlas';

const animations = {
  INTRO: 'Intro',
  INTRO2: 'Intro2',
  TRANSITION: 'transition',
};

const skins = {};

export default {
  id: SpineAnimationIds.KL_VICTORY,
  animations,
  skins,
  atlas,
  images: {
    'victory.png': image,
  },
  json,
};
